<template>
    <v-container style="max-width: 600px;">
        <v-img :style="backgroundImage">
            <v-layout wrap>
                <v-flex mb-4 text-xs-center v-if="user.Id == -1 || !mounted">
                    <br/><br/><br/><br/><br/><br/><br/><br/><br/>
                    <p class="display-3 font-weight-bold mb-3">
                        Un momento...
                    </p>
                    <p class="display-1 font-weight-bold mb-3">
                        Cargando información de ajustador
                    </p>
                    <br/><br/><br/><br/>
                </v-flex>
                <v-flex mb-4 text-xs-center v-if="user.Id > 0 && mounted">
                    <p class="subheading font-weight-regular">
                        <v-img
                            v-bind:src="user.Image"
                            :style="userImage"
                        ></v-img>
                    </p>
                    <br/><br/><br/>
                    <p class="display-1 font-weight-bold mb-3">
                      {{ user.First_name }} {{ user.Last_name }}
                    </p>
                    <h3>{{ user.Certified }}</h3>
                    <p class="subheading font-weight-regular">
                      Código: {{ user.Ref }}
                    </p>
                    <h3>{{ user.Parent_organization }}</h3>
                    <p class="subheading font-weight-regular">
                      Vence: {{ Valid_thru }}
                    </p>
                    <br/><br/><br/><br/>
                </v-flex>
                <v-flex mb-4 text-xs-center v-if="user.Id == 0 && mounted">
                    <br/><br/><br/><br/><br/><br/><br/><br/><br/>
                    <p class="display-3 font-weight-bold mb-3">
                        ADVERTENCIA
                    </p>
                    <p class="display-1 font-weight-bold mb-3">
                        No se encontró referencia de ajustador válida.   Proceda con precaución.
                    </p>
                    <br/><br/><br/><br/>
                </v-flex>
            </v-layout>
        </v-img>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  export default {
      data: () => ({
          user: {
              Id: -1,
              First_name: '',
              Last_name: '',
              Email: '',
              Parent_organization: 'CARGANDO DATOS DE AGENTE',
              Image: '',
          },
          Valid_thru: '',
          mounted: false
      }),

      mounted() {
          this.getUser()
      },

      computed : {
          backgroundImage(){
              return "background-image : url('" + require('@/assets/background.png') + "'); background-size: cover; background-position: top center;";
          },
          userImage(){
              return "width: 200px; height: 200px; margin:auto; border-radius: 50%; display: block; top: 70px;";
          }
      },

      methods: {
          getUser() {
              var self = this;
              var token = this.$route.query.t;
              axios.post('https://casa.sites09.org/v1/users/validate', {Token: token}).then(response => {
              // axios.post('http://localhost:8081/v1/users/validate', {Token: token}).then(response => {
                  self._data.user = response.data.data;
                  self._data.Valid_thru = moment.parseZone(response.data.data.Valid_thru).format('DD/MM/YYYY');
                  self.mounted = true;
              });
          }
      }
  }

</script>

<style>

</style>
